// @flow

import { createImageUrl } from '@nrk/serum-imagecrop-utils'

type SrcSetOpts = {
  id: string,
  ratio?: string,
  quality?: number
}

export const IMAGE_WIDTHS = [320, 450, 650, 768, 900, 1280, 1600, 1920, 2400]

export function createSrcSet (opts: SrcSetOpts) {
  const { id, ratio, quality } = opts

  return IMAGE_WIDTHS.map(width => {
    const imageUrl = createImageUrl({ id, width, ratio, quality })
    return `${imageUrl} ${width}w`
  }).join(', ')
}



// WEBPACK FOOTER //
// ./src/v1/menu/components/CoverPicture/helpers.js